/**
 * Client-safe contract for FirstPromoter rate limiting (FRONT-496). The server routes answer
 * 503 with this code when FirstPromoter's Cloudflare zone throttles us; the client must show a
 * temporary state — never the "not connected to the Creator Program" onboarding — and must not
 * retry, because each retry fans out to four more FirstPromoter calls inside the same window.
 */
export const FIRSTPROMOTER_RATE_LIMITED = 'FIRSTPROMOTER_RATE_LIMITED';

export const FIRSTPROMOTER_RATE_LIMITED_MESSAGE =
  'Creator Program data is temporarily unavailable. Please try again in a minute.';

export class FirstPromoterUnavailableError extends Error {
  constructor(message: string = FIRSTPROMOTER_RATE_LIMITED_MESSAGE) {
    super(message);
    this.name = 'FirstPromoterUnavailableError';
  }
}

export function isFirstPromoterUnavailable(error: unknown): boolean {
  return error instanceof FirstPromoterUnavailableError;
}

/** TanStack `retry` predicate: one retry for ordinary failures, none for a rate limit. */
export function retryUnlessRateLimited(failureCount: number, error: unknown): boolean {
  return !isFirstPromoterUnavailable(error) && failureCount < 1;
}
